import styled from 'styled-components';

import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';

const ContainerStyle = () => ({
  flexDirection: 'column',
  flex: 1,
  padding: '40px 25px',
  overflowY: 'auto',
});
export const Container = styled(Box)(ContainerStyle);

const SubtitleStyle = (props) => ({
  marginTop: props.theme.space.sm,
});
export const Subtitle = styled(Text)(SubtitleStyle);
